import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'reactstrap';
import { Container } from './styles';

function Error() {
  const history = useHistory();

  return (
    <Container>
      <section>
        <h1>ERROR 404 - Página não encontrada</h1>
        <Button
          onClick={() => {
            history.push('/');
          }}
          color="warning"
          outline
        >
          Voltar
        </Button>
      </section>
    </Container>
  );
}

export default Error;
